import React, { forwardRef } from 'react';
import { bool, func, number, oneOf, shape, string } from 'prop-types';
import ClassNames from 'classnames';

import './TextArea.scss';

const AUTOCOMPLETE_VALUES = ['on', 'off'];

const TextArea = forwardRef(
  (
    {
      autoComplete,
      autoFocus,
      className,
      cols,
      disabled,
      id,
      invalid,
      maxLength,
      minLength,
      name,
      onBlur,
      onChange,
      onClick,
      onFocus,
      pattern,
      placeholder,
      readOnly,
      rows,
      style,
      value
    },
    ref
  ) => {
    const handleChange = event => {
      if (onChange) {
        onChange(event.target.value);
      }
    };

    return (
      <textarea
        aria-invalid={invalid}
        autoComplete={autoComplete}
        // TODO: Reconsider use of the autoFocus prop.
        // eslint-disable-next-line jsx-a11y/no-autofocus
        autoFocus={autoFocus}
        className={ClassNames('TextArea', className)}
        cols={cols}
        disabled={disabled}
        id={id}
        maxLength={maxLength}
        minLength={minLength}
        name={name}
        onBlur={onBlur}
        onChange={handleChange}
        onClick={onClick}
        onFocus={onFocus}
        pattern={pattern}
        placeholder={placeholder}
        readOnly={readOnly}
        ref={ref}
        rows={rows}
        style={style}
        value={value}
      />
    );
  }
);

TextArea.propTypes = {
  autoComplete: oneOf(AUTOCOMPLETE_VALUES),
  autoFocus: bool,
  className: string,
  cols: number,
  disabled: bool,
  id: string,
  invalid: bool,
  maxLength: number,
  minLength: number,
  name: string,
  onBlur: func,
  onChange: func,
  onClick: func,
  onFocus: func,
  pattern: string,
  placeholder: string,
  readOnly: bool,
  rows: number,
  style: shape({}),
  value: string
};

TextArea.defaultProps = {
  autoComplete: undefined,
  autoFocus: false,
  className: '',
  cols: 50,
  disabled: false,
  id: undefined,
  invalid: false,
  maxLength: undefined,
  minLength: undefined,
  name: '',
  onBlur: () => {},
  onChange: undefined,
  onClick: () => {},
  onFocus: () => {},
  pattern: undefined,
  placeholder: undefined,
  readOnly: false,
  rows: 5,
  style: {},
  value: undefined
};

export default TextArea;
